import { Record, Union } from "../fable_modules/fable-library.3.6.3/Types.js";
import { array_type, option_type, record_type, string_type, int32_type, union_type } from "../fable_modules/fable-library.3.6.3/Reflection.js";
import { DownloadFormat$reflection, TaggedTextInfo$reflection } from "../Shared/fs/Shared.js";

export class TaggingStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NotTagged", "Tagging", "Tagged"];
    }
}

export function TaggingStatus$reflection() {
    return union_type("Model.TaggingStatus", [], TaggingStatus, () => [[], [], []]);
}

export class Lemma extends Record {
    constructor(Frequency, Form, Pos) {
        super();
        this.Frequency = (Frequency | 0);
        this.Form = Form;
        this.Pos = Pos;
    }
}

export function Lemma$reflection() {
    return record_type("Model.Lemma", [], Lemma, () => [["Frequency", int32_type], ["Form", string_type], ["Pos", string_type]]);
}

export class Model extends Record {
    constructor(Filename, TaggingStatus, TaggedTextInfo, Lemmas, DownloadFormat) {
        super();
        this.Filename = Filename;
        this.TaggingStatus = TaggingStatus;
        this.TaggedTextInfo = TaggedTextInfo;
        this.Lemmas = Lemmas;
        this.DownloadFormat = DownloadFormat;
    }
}

export function Model$reflection() {
    return record_type("Model.Model", [], Model, () => [["Filename", option_type(string_type)], ["TaggingStatus", TaggingStatus$reflection()], ["TaggedTextInfo", option_type(TaggedTextInfo$reflection())], ["Lemmas", option_type(array_type(Lemma$reflection()))], ["DownloadFormat", option_type(DownloadFormat$reflection())]]);
}

